import { useEffect, useState } from "react";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import { useInView } from "react-intersection-observer";
import Jet from "../../images/Jet.svg";
import digikalaBusiness from "../../images/digikalaBusiness.svg";
import DKmehr from "../../images/DKmehr.svg";
import GANJE from "../../images/GANJE.svg";
import Magnet from "../../images/Magnet.svg";

const RowNewjoiners = () => {
  const [refFact1, refFact1InView] = useInView();
  const [refFact1isVisible, setrefFact1IsVisible] = useState(false);
  useEffect(() => {
    if (refFact1InView && !refFact1isVisible) {
      setrefFact1IsVisible(true);
    } else if (!refFact1InView && refFact1isVisible) {
      setrefFact1IsVisible(false);
    }
  }, [refFact1isVisible, refFact1InView]);

  return (
    <div className="color-dk-r">
      <div className="row m-0 flex-row-reverse text-center">
        <div className="stickyRowHeaders col-lg-4 col-12 d-flex align-items-center justify-content-center  bg-color-gr">
          <div className="d-lg-none d-inline">
            <div>Subsidaries of Digikala in 2021-22</div>
          </div>
          <div className="d-none d-lg-block">
            <ParallaxProvider>
              <Parallax
                translateY={[-200, 100]}
                opacity={[1, 0.8]}
                easing="easeOut"
                scale={[0.8, 1]}
              >
                <div>Subsidaries of Digikala in 2021-22</div>
              </Parallax>
            </ParallaxProvider>
          </div>
        </div>

        <div className="col-lg-8 col-12 text-start color-dk-dark line-height-lg px-2 px-lg-4 bg-color-w py-4">
          <div
            ref={refFact1}
            className={
              refFact1isVisible
                ? "fade-in-section is-visible row m-0 text-center py-2"
                : "fade-in-section row m-0 text-center py-2"
            }
          >
            <div className="row mx-0 justify-content-start">
              <div className="col-6 col-lg-3 p-3">
                <img className="mb-3 w-50 w-lg-25" src={GANJE} alt="GANJE" />
                <h6 className="bg-color-gr dk-medium dk-bold py-4 radius4 ">
                  GANJE
                </h6>
                <p className="dk-small pt-3 text-start">
                  Intelligent urban lockers named “GANJE” were established to
                  solve the challenge of discoordination in delivery
                  destinations. Users can choose to receive their orders at any
                  of the lockers located all around the city.
                </p>
              </div>
              <div className="col-6 col-lg-3 p-3">
                <img className="mb-3 w-50 w-lg-25" src={Magnet} alt="Magnet" />
                <h6 className="bg-color-gr dk-medium dk-bold py-4 radius4">
                  Magnet
                </h6>
                <p className="dk-small pt-3 text-start">
                  Magnet is the latest product of Digikala Group, built for
                  allowing customers to write product reviews, with focus on
                  video contents. This platform allows users to explore the
                  whole collection of contents created before, all in one place
                </p>
              </div>
              <div className="col-6 col-lg-3 p-3">
                <img
                  className="mb-3 w-50 w-lg-25"
                  src={digikalaBusiness}
                  alt="digikalaBUSINESS"
                />
                <h6 className="bg-color-gr dk-medium dk-bold py-4 radius4">
                  digikalaBUSINESS
                </h6>
                <p className="dk-small pt-3 text-start">
                  digikalaBUSINESS is a simple yet reliable method for corporate
                  shopping and supplying business requirements. All businesses,
                  NGOs and governmental organizations can benefit from the
                  corporate shopping experience with official receipts and
                  stepwise installments using digikalaBUSINESS.
                </p>
              </div>
              <div className="col-6 col-lg-3 p-3">
                <img
                  className="mb-3 w-50 w-lg-25"
                  src={DKmehr}
                  alt="digikalamehr"
                />
                <h6 className="bg-color-gr dk-medium dk-bold py-4 radius4">
                  digikalamehr
                </h6>
                <p className="dk-small pt-3 text-start">
                  digikalamehr was unveiled with the goal of recommending a
                  simple and transparent solution for in-kind donations. The
                  road of kindness in digikalamehr is similar to shopping at
                  Digikala; However, users’ purchases will be delivered to
                  charity NGOs as in- kind donations to specific vulnerable
                  target groups.
                </p>
              </div>
              <div className="col-6 col-lg-3 p-3">
                <img
                  className="mb-3 w-50 w-lg-25"
                  src={Jet}
                  alt="digikalajet"
                />
                <h6 className="bg-color-gr dk-medium dk-bold py-4 radius4">
                  digikalajet
                </h6>
                <p className="dk-small pt-3 text-start">
                  digikalajet started its job with the mission of free quick
                  delivery of FMCG orders. digiexpress’s intelligent logistics
                  network and infrastructure helped digikalajet to push the
                  delivery process KIPs as closest to ideal as possible.
                  digikalajet is assumed to be one of the key players of Iran’s
                  Quick Commerce - Q - commerce.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RowNewjoiners;
